import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { getLabelForId } from '../../utils';
import LivestreamLatestVideosUI from './LivestreamLatestVideosUI';
const LivestreamLatestVideos = t0 => {
  const $ = _c(9);
  const {
    videos,
    videoCategories: t1
  } = t0;
  const videoCategories = t1 === undefined ? [] : t1;
  const [selectedFilter, setSelectedFilter] = useState("all");
  const selectedFilterLabel = getLabelForId(videoCategories, selectedFilter);
  const [searchText, setSearchText] = useState("");
  let t2;
  if ($[0] !== searchText) {
    t2 = video_0 => searchText ? video_0.title.toLowerCase().includes(searchText.toLowerCase()) || video_0.category.toLowerCase().includes(searchText.toLowerCase()) : true;
    $[0] = searchText;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const filteredVideos = videos.filter(video => selectedFilter === "all" || video.categories.includes(selectedFilterLabel)).filter(t2);
  let t3;
  if ($[2] !== filteredVideos || $[3] !== searchText || $[4] !== selectedFilter || $[5] !== setSearchText || $[6] !== setSelectedFilter || $[7] !== videoCategories) {
    t3 = <LivestreamLatestVideosUI searchText={searchText} setSearchText={setSearchText} selectedFilter={selectedFilter} setSelectedFilter={setSelectedFilter} videoCategories={videoCategories} videos={filteredVideos} />;
    $[2] = filteredVideos;
    $[3] = searchText;
    $[4] = selectedFilter;
    $[5] = setSearchText;
    $[6] = setSelectedFilter;
    $[7] = videoCategories;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
LivestreamLatestVideos.propTypes = {
  videoCategories: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    id: PropTypes.string
  })),
  videos: PropTypes.arrayOf(PropTypes.shape({
    slug: PropTypes.string,
    category: PropTypes.string,
    image: PropTypes.string,
    isRecordedLive: PropTypes.bool,
    title: PropTypes.string,
    videoId: PropTypes.string,
    videoLength: PropTypes.string
  }))
};
export default LivestreamLatestVideos;